import React, { Component } from 'react';
import { client } from '../../lib/api';
import { dateFormatter } from '../../lib/formatter';
import Loading from '../common/Loading';
import Page from '../common/Page';
import PageTable from '../common/PageTable';
import ExpiredWall from '../ExpiredWall';

class ClientList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            clients: null,
            loading: true
        };

        this.refresh = this.refresh.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onClone = this.onClone.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        client.list()
            .then(clients => this.setState({
                clients: clients,
                loading: false
            }))
            .catch(error => this.setState({
                clients: null,
                loading: true
            }));
    }

    onAdd() {
        this.props.history.push(`/clientes/adicionar`);
    }

    onEdit(id) {
        this.props.history.push(`/clientes/${id}/editar`);
    }

    onClone(id) {
        client.clone(id)
            .then(json => {
                this.refresh();
            })
            .catch(error => {
                console.log(error);
            });
    }

    onDelete(id, row) {
        if (!window.confirm(`Deseja mesmo apagar o cliente "${row.name}"?`)) {
            return;
        }

        client.remove(id)
            .then(json => {
                this.refresh();
            })
            .catch(error => {
                console.log(error);
            });
    }

    onRowClick(id) {
        this.props.history.push(`/clientes/${id}`);
    }

    render() {
        if (this.props.user.plan === 'EXPIRED') {
            return <ExpiredWall />;
        }

        if (this.state.loading) {
            return (
                <Page title="Clientes">
                    <Loading />
                </Page>
            );
        }

        const isTrial = this.props.user.plan === 'TRIAL' || this.props.user.plan === 'EXPIRED';

        const isDisabled = isTrial && this.state.clients.length >= 1;

        const actions = (
            <div className="buttons is-right">
                <button title="Adicionar Cliente" className="button is-light is-primary" disabled={isDisabled} onClick={this.onAdd}>
                    <span className="icon">
                        <i className="fas fa-plus"></i>
                    </span>
                    <span>Adicionar</span>
                </button>
            </div>
        );

        const inlineActions = (value, row) => (
            <div className="buttons is-right">
                <button title="Editar" className="button is-small is-light is-info" onClick={() => this.onEdit(value, row)}>
                    <span className="icon is-small">
                        <i className="fas fa-pencil-alt"></i>
                    </span>
                </button>
                <button title="Duplicar" className="button is-small is-light is-info" onClick={() => this.onClone(value, row)}>
                    <span className="icon is-small">
                        <i className="fas fa-copy"></i>
                    </span>
                </button>
                <button title="Apagar" className="button is-small is-light is-danger" onClick={() => this.onDelete(value, row)}>
                    <span className="icon is-small">
                        <i className="far fa-trash-alt"></i>
                    </span>
                </button>
            </div>
        );

        return (
            <PageTable
                title="Clientes"
                columns={[
                    { key: "name",       title: "Nome",            searchable: true,  sortable: true, headerClassName: "is-nowrap is-unselectable has-text-left",                  rowClassName: "is-nowrap" },
                    { key: "vat",        title: "NIF / NIPC",      searchable: true,  sortable: true, headerClassName: "is-nowrap is-unselectable has-text-left is-hidden-mobile", rowClassName: "is-nowrap is-hidden-mobile" },
                    { key: "location",   title: "Localidade",      searchable: true,  sortable: true, headerClassName: "is-nowrap is-unselectable has-text-left is-hidden-mobile", rowClassName: "is-nowrap is-hidden-mobile" },
                    { key: "created_at", title: "Data de Criação", searchable: false, sortable: true, headerClassName: "is-nowrap is-unselectable has-text-left is-hidden-mobile", rowClassName: "is-nowrap is-hidden-mobile", formatter: dateFormatter }
                ]}
                rows={this.state.clients}
                actions={actions}
                inlineActions={inlineActions}
                // onRowClick={this.onRowClick}
                orderBy="name"
                orderAscending={true}
            />
        );
    }
}

export default ClientList;
